import * as React from 'react';

import Spinner from '@developers/uikit/Spinner';

import styles from './PageLoadingIndicator.module.css';

const PageLoadingIndicator = () => (
  <div className={styles.wrapper}>
    <Spinner />
  </div>
);

export default PageLoadingIndicator;
